import { Component, ChangeDetectionStrategy, ViewEncapsulation, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Content, DynamicViewDirective } from '../../../overview';
import { Command } from '@workbuddy/ui/model';
import { ButtonComponent } from '@workbuddy/ui/components/button';

@Component({
    selector: 'w-list-item',
    templateUrl: 'content.list.item.component.html',
    styleUrls: ['content.list.item.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        DynamicViewDirective,
        ButtonComponent
    ]
})
export class ContentListItemComponent {

    public $icon = input<Content>(null, { alias: 'icon' });
    public $header = input<Content>(null, { alias: 'header' });
    public $description = input<Content>(null, { alias: 'description' });
    public $content = input<Content>(null, { alias: 'content' });
    public $rightContent = input<Content>(null, { alias: 'rightContent' });
    public $chevron = input<Content>(null, { alias: 'chevron' });

    public $action = input<Content>(null, { alias: 'action' });
    public $command = input<Command>(null, { alias: 'command' });

    public $iconBackground = input<string>(null, { alias: 'iconBackground' });
    public $iconColor = input<string>(null, { alias: 'iconColor' });
    public $iconFont = input<boolean>(true, { alias: 'iconFont' });
}
